import { ExportModal, ExportModalProps } from './ExportModal';
import React, { useCallback, useState } from 'react';
import { actions, elements } from '@ecosystem/newron-design-system';
import { registerCommonActionsMenuItem } from '../components/CommonActionsMenu';

const { Icon } = elements;
const { Menu } = actions;

export type ExportMenuItemProps = Omit<ExportModalProps, 'isShown'>;

export function ExportMenuItem(props: ExportMenuItemProps) {
  const { onClose } = props;

  const [isShown, setIsShown] = useState(false);

  const handleClose = useCallback(() => {
    setIsShown(false);
    onClose?.();
  }, [onClose]);

  return (
    <>
      <Menu.Item onSelect={() => setIsShown(true)} testId="export-menu-item">
        <Icon>
          <Icon.icons.Export />
        </Icon>
        Export
      </Menu.Item>
      <ExportModal {...props} isShown={isShown} onClose={handleClose} />
    </>
  );
}

registerCommonActionsMenuItem(ExportMenuItem, 1);
